import React, { useCallback, useState } from 'react';
import { Box, RootRef } from '@material-ui/core';
import { SectionDrawer, SectionListContainer, ButtonContainer } from './style';
import SectionList from './SectionList';
import CreateSectionButton from './CreateSectionButton';
import { SectionSettingsDrawerProps } from './types';

const SectionSettingsDrawer = ({ isOpen, close, offset }: SectionSettingsDrawerProps) => {
    const [height, setHeight] = useState<number | undefined>(undefined);

    const measuredRef = useCallback(node => {
        if (node !== null) {
            setHeight(node.getBoundingClientRect().height);
        }
    }, []);

    return (
        <SectionDrawer
            BackdropProps={{ invisible: true }}
            offset={offset}
            anchor='right'
            open={isOpen}
            onClose={close}
        >
            <RootRef rootRef={measuredRef}>
                <Box display='flex' flexDirection='column' flexGrow={1}>
                    <SectionListContainer parentHeight={height}>
                        <SectionList />
                    </SectionListContainer>
                    <ButtonContainer>
                        <CreateSectionButton />
                    </ButtonContainer>
                </Box>
            </RootRef>
        </SectionDrawer>
    );
};

export default SectionSettingsDrawer;
